export const normalizeCityName = cityName => {
    if (!cityName) return "";
    return cityName
        ?.toLocaleLowerCase("tr-TR")
        ?.replace(/ asya| avrupa| tümü/g, "")
        ?.replace(/[()]/g, "")
        ?.replace(/\s+/g, "")
        ?.trim();
};
